import React from 'react'
import { withStyles, createStyles } from '@material-ui/core/styles'
import type { WithStyles } from '@material-ui/core/styles'
import MuiLinearProgress from '@material-ui/core/LinearProgress'
import type { LinearProgressProps as MuiLinearProgressProps } from '@material-ui/core/LinearProgress'

const styles = createStyles({
  root: {},
  bar: {},
  barColorPrimary: {},
  barColorSecondary: {},
  colorPrimary: {},
  colorSecondary: {}
})

export interface LinearProgressProps extends WithStyles<typeof styles>, Omit<MuiLinearProgressProps, 'classes'> {}

function LinearProgress(props: LinearProgressProps) {
  const { classes, ...otherProps } = props
  const baseClasses = { ...classes }

  return <MuiLinearProgress {...otherProps} classes={baseClasses} />
}

LinearProgress.defaultProps = {
  color: 'primary' as const
}

export default withStyles(styles)(LinearProgress)
